export enum GameStage {
  BLINDS = 'BLINDS',
  PREFLOP = 'PREFLOP',
  FLOP = 'FLOP',
  TURN = 'TURN',
  RIVER = 'RIVER',
  SHOWDOWN = 'SHOWDOWN',
  GAME_FINISHED = 'GAME_FINISHED',
}
